if (!window.awCountdownLoaded) {
  window.awCountdownLoaded = true;

  const pad = (value) => String(Math.max(0, value)).padStart(2, '0');

  const initTimers = (root) => {
    root.querySelectorAll('[data-aw-countdown]:not(.aw-countdown-ready)').forEach((el) => {
      el.classList.add('aw-countdown-ready');

      const rawEnd = el.dataset.end;
      if (!rawEnd) return;

      const endDate = new Date(rawEnd.trim().replace(' ', 'T'));
      if (Number.isNaN(endDate.getTime())) return;

      const hideExpired = el.dataset.hideExpired === 'true';
      const daysEl = el.querySelector('[data-unit="days"]');
      const hoursEl = el.querySelector('[data-unit="hours"]');
      const minutesEl = el.querySelector('[data-unit="minutes"]');
      const secondsEl = el.querySelector('[data-unit="seconds"]');
      const statusEl = el.querySelector('[data-aw-countdown-status]');

      let intervalId = null;

      const stop = () => {
        if (intervalId) window.clearInterval(intervalId);
        if (hideExpired) {
          el.hidden = true;
        } else {
          const timer = el.querySelector('[data-aw-countdown-timer]');
          if (timer) timer.remove();
        }
      };

      const tick = () => {
        const diff = endDate.getTime() - Date.now();
        if (diff <= 0) {
          stop();
          return;
        }

        const days = Math.floor(diff / 86400000);
        const hours = Math.floor((diff % 86400000) / 3600000);
        const minutes = Math.floor((diff % 3600000) / 60000);
        const seconds = Math.floor((diff % 60000) / 1000);

        if (daysEl) daysEl.textContent = pad(days);
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minutesEl) minutesEl.textContent = pad(minutes);
        if (secondsEl) secondsEl.textContent = pad(seconds);

        if (statusEl && seconds === 0) {
          statusEl.textContent = `${days}d ${hours}h ${minutes}m remaining`;
        }
      };

      intervalId = window.setInterval(tick, 1000);
      tick();
    });
  };

  const initCopyButtons = (root) => {
    root.querySelectorAll('[data-aw-countdown-code]:not(.aw-countdown-code-ready)').forEach((button) => {
      button.classList.add('aw-countdown-code-ready');
      button.addEventListener('click', () => {
        const code = button.dataset.code;
        if (!code || !navigator.clipboard) return;
        navigator.clipboard
          .writeText(code)
          .then(() => {
            button.classList.add('is-copied');
            window.setTimeout(() => button.classList.remove('is-copied'), 1800);
          })
          .catch(() => {});
      });
    });
  };

  const initAwCountdown = (root = document) => {
    initTimers(root);
    initCopyButtons(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAwCountdown());
  } else {
    initAwCountdown();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => initAwCountdown(event.target));
  }
}
